import { Image } from "expo-image";
import { PixelRatio } from "react-native";
import { Radius } from "~/constants/sizing";

export type QendoLogoProps = {
    size?: number;
};

const icon_source = require("~/assets/adaptive-icon.png");

export const QendoLogo = ({ size = 24 }: QendoLogoProps) => {
    return (
        <Image
            source={icon_source}
            style={{
                width: size,
                height: size,
                flexShrink: 0,
                flexGrow: 0,
                borderRadius: PixelRatio.roundToNearestPixel(Math.min(Math.max(Radius.xs, size / 6), Radius.xl)),
            }}
        />
    );
};
